<template>
  <!-- share-network comes from the vue-social-sharing library (globally registered), not a local component -->
  <share-network
    :id="`link-share-${network}`"
    ref="shareNetworkRef"
    :network="shareNetworkName"
    :url="url"
    :title="title"
    :description="description"
    :aria-label="`Share on ${network}`"
    class="icon"
    @open="runWorkaround"
  >
    <svg
      class="share-this-icon"
      aria-hidden="true"
    >
      <use
        :xlink:href="`#icon-${network}`"
      />
    </svg>
  </share-network>
</template>

<script>
import { computed, ref } from 'vue'

export default {
  name: 'share-this',
  props: {
    url: String,
    title: {
      type: String,
      required: false
    },
    description: {
      type: String,
      required: false
    },
    network: String,
  },
  setup(props) {
    const shareNetworkRef = ref(null)

    // vue-social-sharing has no 'x' network, only 'twitter' (same sharer URL)
    const shareNetworkName = computed(() => (props.network === 'x' ? 'twitter' : props.network))

    function runWorkaround() {
      if (shareNetworkRef.value === null) return

      clearInterval(shareNetworkRef.value.popupInterval)
      shareNetworkRef.value.popupWindow = undefined
    }

    return { shareNetworkRef, shareNetworkName, runWorkaround }
  }
}
</script>

<style scoped lang="scss">
.share-this-icon {
  width: 2rem;
  height: 2rem;
}
</style>
